import React from 'react'
import PropTypes from 'prop-types'
import TriangleExclamationIcon from '../../ui/icons/TriangleExclamationIcon'

const MET = 'met'
const STALE_MESSAGE = 'Ne remplit plus la condition'

const LINES_CLASS = 'tw:flex tw:flex-col tw:gap-1'
const STALE_CLASS = 'tw:block tw:text-xs tw:text-orange-200'
const WARNING_CLASS = 'tw:inline-flex tw:shrink-0'
const WARNING_ICON_CLASS = 'tw:size-3.5'

export const TRIGGER_STATE_SHAPE = PropTypes.shape({
  status: PropTypes.string,
  text: PropTypes.string
})

export const hasStaleState = states => states.some(state => state.status !== MET)

export const TRIGGER_WARNING = (
  <span aria-label="Déclencheur à vérifier" className={WARNING_CLASS} role="img">
    <TriangleExclamationIcon className={WARNING_ICON_CLASS} />
  </span>
)

const TriggerStates = ({ states }) => (
  <span className={LINES_CLASS}>
    {states.map(state => (
      <span key={state.text}>
        {state.text}
        {state.status === MET ? null : <span className={STALE_CLASS}>{STALE_MESSAGE}</span>}
      </span>
    ))}
  </span>
)

TriggerStates.propTypes = {
  states: PropTypes.arrayOf(TRIGGER_STATE_SHAPE).isRequired
}

export default TriggerStates
